import { atom } from 'nanostores';
// Atom for tracking user status
export const $userStatusAtom = atom('unknown');
